import React, { useEffect } from "react";

import Header from "../../components/header/header";

import "./bookingThankyouPage.css";

const BookingThankyouPage = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY; // Get the current scroll position
      const element = document.querySelector("header");
      if (element) {
        if (scroll >= 10) {
          element.classList.add("lightHeader");
        } else {
          document.querySelector("header").classList.remove("lightHeader");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup the event listener on unmount
    };
  }, []);
  return (
    <>
      <Header></Header>
      <div className="content_">
        {/* Content Inner */}
        <div className="content__inner">
          <div className="overflow-hidden">
            {/* Multi-steps Form */}
            <div className="multisteps-form">
              <div className="progress-row">
                {/* Progress Bar */}
                <div className="row">
                  <div className="col-12 col-lg-12 ml-auto mr-auto mb-4 mt-5">
                    <div className="multisteps-form__progress flex space-x-4">
                      <button
                        className="multisteps-form__progress-btn js-active bg-blue-500 text-white py-2 px-4 rounded"
                        type="button"
                        title="Service Class"
                      >
                        <span>Service Class</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn js-active  bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Pickup Info"
                      >
                        <span>Pickup Info</span>
                      </button>
                      {/* Commented Button */}
                      {/* <button className="multisteps-form__progress-btn" type="button" title="Log In">
                    <span>Log In</span>
                </button> */}
                      <button
                        className="multisteps-form__progress-btn js-active  bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Payment"
                      >
                        <span>Payment</span>
                      </button>
                      <button
                        className="multisteps-form__progress-btn js-active bg-gray-200 text-gray-700 py-2 px-4 rounded hover:bg-blue-500 hover:text-white transition"
                        type="button"
                        title="Thankyou"
                      >
                        <span>Thank You</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-8 m-auto">
                  <form class="multisteps-form__form">
                    <div
                      className="multisteps-form__panel_thankyou thank_you"
                      data-animation="scaleIn"
                    >
                      <div className="step_details w-450 mb-5 text-center">
                        <div className="tick">
                          <img
                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJVtetWi_-HyRLJy6NwriI3BzontyhO9w0ZQ&s"
                            width="60px"
                            alt="Thank You Tick"
                          />
                        </div>
                        <h3 className="additional-heading mt-4">
                          Thank You for Your Booking!
                        </h3>
                        <p className="additional-note">
                          We appreciate your business and look forward to
                          providing you with a smooth and safe ride. Enjoy your
                          trip!
                        </p>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingThankyouPage;
